// src/pages/customerComponents/RemoteBusinessComponents/RemoteLanding.js

import React, { useState, useRef } from 'react';
import ProcessSteps from './ProcessSteps';
import '../../../styles/CustomerSiteStyles/RemoteLanding.css';
import videoSrc from '../../../assets/videos/RemoteLandingPageVideo.mp4';

const RemoteLanding = () => {
  const [videoActive, setVideoActive] = useState(false);
  const videoRef = useRef(null);

  const handlePlay = () => {
    setVideoActive(true);
    setTimeout(() => {
      if (videoRef.current) videoRef.current.play();
    }, 0);
  };

  return (
    <div className="remote-landing">

      {/* Hero Section */}
      <section className="remote-hero">
        <div className="remote-hero__tag">Exclusive Offer</div>
        <h1 className="remote-hero__headline">
          Storm Damage? <span className="remote-hero__accent">We've Got You Covered.</span>
        </h1>
        <p className="remote-hero__subtext">
          Affordable Roofing + Solar Solutions works directly with your insurance — from inspection
          to build — so you never have to navigate the process alone.
        </p>
      </section>

      {/* Video Section */}
      <section className="remote-video-section">
        <div className="remote-video-section__label">Hear It From Our Owner</div>
        <div className="remote-video-wrapper">

          {/* Native video element — always in DOM so it can preload */}
          <video
            ref={videoRef}
            className={`remote-video-player ${videoActive ? 'remote-video-player--active' : ''}`}
            src={videoSrc}
            controls
            playsInline
            preload="metadata"
          />

          {/* Poster overlay — hidden once play is clicked */}
          {!videoActive && (
            <button
              className="remote-video-poster"
              onClick={handlePlay}
              aria-label="Play video"
            >
              <video
                className="remote-video-poster__thumb"
                src={`${videoSrc}#t=0.5`}
                muted
                playsInline
                preload="metadata"
              />
              <span className="remote-video-poster__play">
                <svg viewBox="0 0 68 48" xmlns="http://www.w3.org/2000/svg">
                  <path className="play-btn-bg" d="M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55c-2.93.78-4.63 3.26-5.42 6.19C.06 13.05 0 24 0 24s.06 10.95 1.48 16.26c.78 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.64-3.26 5.42-6.19C67.94 34.95 68 24 68 24s-.06-10.95-1.48-16.26z"/>
                  <path className="play-btn-arrow" d="M45 24 27 14v20"/>
                </svg>
              </span>
            </button>
          )}

        </div>
      </section>

      {/* CTA Buttons */}
      <section className="remote-cta-section">
        <div className="remote-cta-section__inner">
          <a href="https://scheduler.zoom.us/affordable-roofing-solutions" target="_blank" rel="noopener noreferrer" className="remote-cta-btn remote-cta-btn--primary">
            <span className="remote-cta-btn__icon">📅</span>
            <span>
              <strong>Schedule a Virtual Call</strong>
              <small>Talk to a rep about your inspection</small>
            </span>
          </a>
          <a href="/affiliate" className="remote-cta-btn remote-cta-btn--secondary">
            <span className="remote-cta-btn__icon">🤝</span>
            <span>
              <strong>Join Our Affiliate Program</strong>
              <small>Earn by referring homeowners</small>
            </span>
          </a>
        </div>
      </section>

      {/* Process Steps */}
      <ProcessSteps />

    </div>
  );
};

export default RemoteLanding;